import { clamp } from "../util/math.ts";

export const toDesc = (certainty: number): string => {
  return `${(clamp(certainty, 0, 1) * 100).toFixed()}%`;
};
